/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PortalSettingsResponse } from '../models/portal-settings-response';

@Injectable({
  providedIn: 'root',
})
export class PortalService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPortalSettingShow
   */
  static readonly GetPortalSettingShowPath = '/api/web/v1/portals/settings';

  /**
   * Get portal settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPortalSettingShow()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortalSettingShow$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
'message': string;
'data': PortalSettingsResponse;
}>> {

    const rb = new RequestBuilder(this.rootUrl, PortalService.GetPortalSettingShowPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'message': string;
        'data': PortalSettingsResponse;
        }>;
      })
    );
  }

  /**
   * Get portal settings.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPortalSettingShow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortalSettingShow(params?: {
    context?: HttpContext
  }
): Observable<{
'message': string;
'data': PortalSettingsResponse;
}> {

    return this.getPortalSettingShow$Response(params).pipe(
      map((r: StrictHttpResponse<{
'message': string;
'data': PortalSettingsResponse;
}>) => r.body as {
'message': string;
'data': PortalSettingsResponse;
})
    );
  }

}
